module.exports = __webpack_public_path__ + "img/Penguins_will_bite.04afba2c.webp";